import { render } from "./AddVideo.vue?vue&type=template&id=670a0af8&scoped=true"
import script from "./AddVideo.vue?vue&type=script&lang=js"
export * from "./AddVideo.vue?vue&type=script&lang=js"

import "./AddVideo.vue?vue&type=style&index=0&id=670a0af8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-670a0af8"]])

export default __exports__